var _path, _g, _rect, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMastercard = function SvgMastercard(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 38 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.34315 1.34315 0 3 0H34.3043C35.9612 0 37.3043 1.34315 37.3043 3V23C37.3043 24.6569 35.9612 26 34.3043 26H3C1.34315 26 0 24.6569 0 23V3Z",
    fill: "#262626"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.34766,
    y: 5.65216,
    width: 22.5042,
    height: 14.6788,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.6328,
    y: 8.20953,
    width: 5.9365,
    height: 9.56231,
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.244 12.9916C16.2425 11.1259 17.111 9.36318 18.5991 8.21128C16.071 6.25187 12.4405 6.53727 10.2591 8.86692C8.07769 11.1966 8.07769 14.7883 10.2591 17.1179C12.4405 19.4476 16.071 19.733 18.5991 17.7736C17.1105 16.6213 16.242 14.8579 16.244 12.9916Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9991 16.6057V17.0031H27.9577V16.6057H27.8691V16.5235H28.0933V16.6057H27.9991ZM28.4342 16.5235V17.0031H28.3871V16.64L28.3136 16.9517H28.2627L28.1892 16.64V17.0031H28.1402V16.5235H28.2081L28.2872 16.8661L28.3663 16.5235H28.4342Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5766 12.9915C28.5765 15.3197 27.2285 17.4436 25.105 18.461C22.9816 19.4784 20.4555 19.2108 18.5996 17.7718C20.0871 16.619 20.9556 14.8565 20.9556 12.9907C20.9556 11.1249 20.0871 9.3624 18.5996 8.20952C20.4555 6.77055 22.9816 6.50295 25.105 7.52037C27.2285 8.53779 28.5765 10.6616 28.5766 12.9898V12.9915Z",
    fill: "#F79E1B"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMastercard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mastercard.b30477ec.svg";
export { ForwardRef as ReactComponent };